import React from 'react';
import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import { LOCAL_ONLY_ANNOTATION_KEY } from '../utils';

class ToolShowComments extends Tool {
  static toolName = 'Show comments';
  static iconClass = 'far fa-comment';

  static action({ controller }: ToolArgsWithController): void {
    const provider = controller.ahaEditor.getProvider('annotations');
    if (!provider) return;

    provider.onShowAnnotations();
  }

  static isEnabled(): boolean {
    return true;
  }

  static renderToolbarButtonIcon(
    toolArgs: ToolArgsWithController
  ): JSX.Element {
    const { editor } = toolArgs;
    const icon = <i className={this.iconClass} />;
    if (!editor?.metadata?.annotations) return icon;

    const commentCount = Object.entries(editor.metadata.annotations).filter(
      ([key, annotation]) => {
        return (
          key !== LOCAL_ONLY_ANNOTATION_KEY &&
          annotation &&
          annotation.kind === 'comment' &&
          !annotation.hidden &&
          !annotation.resolved
        );
      }
    ).length;

    return commentCount > 0 ? (
      <>
        {icon}
        <span className="tw-ml-1">{commentCount}</span>
      </>
    ) : (
      icon
    );
  }

  static available({ controller }: ToolArgsWithController): boolean {
    return controller.ahaEditor.hasProvider('annotations');
  }
}

export default ToolShowComments;
